import React from 'react';
import { Status } from '../../../../types/redux/data/dataTypes';
import { mainColors } from '../../../../styling/theme';
import { hexToRGBA } from '../../../../utilities/colorUtilities';
import { percentageToNdecialPlacesNoHundredAddZeros } from '../../../../utilities/numberFormatters';
import {
  getNavReconGapStatus,
  NavReconGapThresholds,
} from './navReconGapStatus';

const PERCENT_DECIMALS = 4;

const gapStatusColors: Record<
  Status.Pass | Status.Alert | Status.Fail,
  { backgroundColor: string; color: string }
> = {
  [Status.Pass]: {
    backgroundColor: mainColors.Pass_veryLight,
    color: mainColors.Pass_darker,
  },
  [Status.Alert]: {
    backgroundColor: hexToRGBA(mainColors.Alert, 0.18),
    color: mainColors.Alert_darker,
  },
  [Status.Fail]: {
    backgroundColor: mainColors.Fail_veryLight,
    color: mainColors.Fail_darker,
  },
};

interface NavReconGapValueCellProps {
  value: number | null | undefined;
  thresholds: NavReconGapThresholds;
}

const NavReconGapValueCell: React.FC<NavReconGapValueCellProps> = ({
  value,
  thresholds,
}) => {
  const status = getNavReconGapStatus(value, thresholds);

  if (status === null) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <span
          style={{
            display: 'inline-block',
            width: '6.5rem',
            boxSizing: 'border-box',
            color: mainColors.NA,
            textAlign: 'center',
          }}
        >
          -
        </span>
      </div>
    );
  }

  const { backgroundColor, color } = gapStatusColors[status];

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <span
        style={{
          display: 'inline-block',
          width: '6.5rem',
          boxSizing: 'border-box',
          backgroundColor,
          color,
          fontWeight: 600,
          padding: '0.2rem 0.5rem',
          borderRadius: '0.2rem',
          textAlign: 'center',
          whiteSpace: 'nowrap',
        }}
      >
        {percentageToNdecialPlacesNoHundredAddZeros(value, PERCENT_DECIMALS)}
      </span>
    </div>
  );
};

export default NavReconGapValueCell;
